import { useCurrentUserQuery } from "data/user/user";
import { useQuery } from "react-query";
import http from "shared/http";

export const lookupQueryKeys = {
  allRoles: ["allRoles"] as const,
  allAgencies: ["allAgencies"] as const,
  allCategories: ["allCategories"] as const,
  allResources: ["allResources"] as const,
};

export const useRolesLookupQuery = () => {
  const { data: user } = useCurrentUserQuery();

  return useQuery(
    [lookupQueryKeys.allRoles, user?.userId],
    async (): Promise<
      { id: number; name: string; isAdminAssign: boolean }[]
    > => {
      try {
        const response = await http.fetchAsync("lookup/roles");
        return response.map((role: any) => ({
          id: role.id,
          name: role.name,
          isAdminAssign: role.isAdminAssign,
        }));
      } catch (error) {
        return [];
      }
    },
    {
      staleTime: 60 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
};

export const useAgenciesLookupQuery = () => {
  const { data: user } = useCurrentUserQuery();

  return useQuery(
    [lookupQueryKeys.allAgencies, user?.userId],
    async (): Promise<
      { agency: string; agencyName: string; company: string }[]
    > => {
      try {
        const response = await http.fetchAsync("lookup/agencies");
        return response.map((x: any) => ({
          agency: x.agency,
          agencyName: x.agencyName,
          company: x.company,
        }));
      } catch (error) {
        return [];
      }
    },
    {
      staleTime: 2 * 60 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
};

export const useResourceCategoriesLookupQuery = () => {
  const { data: user } = useCurrentUserQuery();
  return useQuery(
    [lookupQueryKeys.allCategories, user?.userId],
    async (): Promise<string[]> => {
      try {
        const response = await http.fetchAsync("lookup/categories");
        return response.map((x: any) => x.name);
      } catch (error) {
        return [];
      }
    },
    {
      staleTime: 7 * 24 * 60 * 60 * 1000, // 7 days
      refetchOnWindowFocus: false,
    },
  );
};

export const useResourcesLookupQuery = () => {
  const { data: user } = useCurrentUserQuery();
  return useQuery(
    [lookupQueryKeys.allResources, user?.userId],
    async (): Promise<string[]> => {
      try {
        return await http.fetchAsync("lookup/resources");
      } catch (error) {
        return [];
      }
    },
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  );
};
